// @ts-nocheck

export let app: ng.IModule;
(function(angular, schoolwork12) {

	'use strict';

	var underscore = angular.module('underscore', []);
    underscore.factory('_', function() {
        return window._; //Underscore should be loaded on the page
    });
	// Declare app level module which depends on views, and components
	app = angular
    .module("schoolwork12", ["ui.router",
      "ui.bootstrap",
      "underscore",
      "angular-google-analytics",
      "ckeditor",
      schoolwork12.app.common.name,
      schoolwork12.app.auth.name,
      schoolwork12.app.student.name,
      schoolwork12.app.header.name,
      schoolwork12.app.fulfillment.name,
      schoolwork12.app.fulfillmentApproval.name,
      schoolwork12.app.submission.name,
      schoolwork12.app.k12DataManagement.name,
      schoolwork12.app.graduationPlan.name,
      schoolwork12.app.manageSchoolData.name,
      schoolwork12.app.bulkImport.name,
      schoolwork12.app.studentview.name,
      schoolwork12.app.mailTemplate.name,
      schoolwork12.app.administrationTools.name,
      schoolwork12.app.manageCourseManagement.name,
      "schoolwork12.version"
    ]);

	 //app.factory('$location', downgradeInjectable($locationShim));

		app.config(['AnalyticsProvider', function (AnalyticsProvider) {
		   	// Add configuration code as desired
			AnalyticsProvider
		   		.setAccount(tvAction.analytics.account) //UU-XXXXXXX-X should be your tracking code
		   		.setDomainName(tvAction.analytics.domainName)
		   		.logAllCalls(tvAction.analytics.logAllCalls)
		   		.enterDebugMode(tvAction.analytics.enterDebugMode)
		   		.setPageEvent('$stateChangeSuccess');
		}]);

		app.controller( schoolwork12.app.controller, [ '$window', '$location', 'storage',
                          	schoolwork12.app.auth.services.authentication,
							schoolwork12.app.common.services.eventNotification,

							function($window, $location, storage, authentication, eventNotification) {
								var mainModel = this;
								console.log('appCtrl loaded. Show header.');

							    // Detect browser/tab close
							    $window.onbeforeunload = function () {
							    	if (authentication && authentication.isAuthenticated()
							    			&& authentication.getCurrentUser() != undefined && authentication.hasStudentRole()) {
								    	console.log('Window is closing by a Student.');
								    	authentication.logout();
		                                authentication.clear();
		                                storage.setData('X-API-TOKEN', null);
							    	}
							    };

								mainModel.isShowAppHeader = true;
								if (authentication && authentication.isAuthenticated()) {
									mainModel.currentUser = authentication
											.getCurrentUser();
									mainModel.loginUserRole = authentication
											.getPrimaryRole();
									mainModel.pfUrl = schoolwork12.app.pfEndPoint
											.concat(schoolwork12.app.pfkeycodeLoginEndPoint);		
									mainModel.tvSchoolUrl = schoolwork12.app.tvSchoolEndPoint
											.concat(schoolwork12.app.keycodeLoginEndPoint);
									mainModel.tvEnrollmentUrl = schoolwork12.app.tvEnrollmentEndPoint
											.concat(schoolwork12.app.keycodeLoginEndPoint);
									mainModel.hasComputerRuleManagerRole = authentication
											.hasComputerRuleManagerRole();
									mainModel.hasAdministratorRole = authentication
											.hasAdministratorRole();
									mainModel.hasEnrollmentAdvisorRole = authentication
											.hasEnrollmentAdvisorRole();
									mainModel.hasCounselorStaffRole = authentication
											.hasCounselorStaffRole();
									mainModel.hasGradPlanManagerRole = authentication
											.hasGradPlanManagerRole();
									mainModel.hasTeacherRole = authentication.
														hasTeacherRole();
									mainModel.isSchoolActive = authentication
											.isSchoolActive();
									mainModel.isGradPlanOn = authentication
											.isGradPlanOn();
									mainModel.isCRETrackingOn = authentication
											.isCRETrackingOn();
									mainModel.isEnrollmentOn = authentication.isEnrollmentOn();
									mainModel.showTVEInQuickLinks = authentication.showTVEInQuickLinks();
									mainModel.showPFInQuickLinks = authentication.showPFInQuickLinks();
									mainModel.hasSchoolDataManagementRole = authentication
											.hasSchoolDataManagementRole();
									mainModel.hasBulkImportRole = authentication.hasBulkImportRole();
									mainModel.hasBulkAttendanceAdjusterRole = authentication
											.hasBulkAttendanceAdjusterRole();
									mainModel.hasBulkEditAdditionRequirementRole = authentication
																	.hasBulkEditAdditionRequirementRole();
									mainModel.hasProgParticipantMgrRole = authentication
																	.hasProgParticipantMgrRole();
									mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
									mainModel.hasCourseManagementRole = authentication.hasCourseManagementRole();
									mainModel.hasbulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
									mainModel.haspathwayRequirementsRole = authentication.haspathwayRequirementsRole();
									mainModel.hasPathwayRequirementEditRole = authentication.hasPathwayRequirementEditRole();

								};

								eventNotification
										.subscribe(
												schoolwork12.app.auth.events.userLoggedIn,
												function() {
													if (authentication.hasStudentRole()) {
														console.log('Logged in user is a student. Do not show header.');
														mainModel.isShowAppHeader = false;
													} else if (authentication.hasLCRole()) {
														console.log('Logged in user is a LC. Do not show header.');
														mainModel.isShowAppHeader = false;
													} else {
														console.log('Logged in user is NOT a student. Show header.');
														mainModel.isShowAppHeader = true;
													}
                                                    storage.setData('X-API-TOKEN', angular.toJson(authentication.getCurrentUser()));
													mainModel.currentUser = authentication
															.getCurrentUser();
													mainModel.loginUserRole = authentication
															.getPrimaryRole();
													mainModel.pfUrl = schoolwork12.app.pfEndPoint
															.concat(schoolwork12.app.pfkeycodeLoginEndPoint);			
													mainModel.tvSchoolUrl = schoolwork12.app.tvSchoolEndPoint
															.concat(schoolwork12.app.keycodeLoginEndPoint);
													mainModel.tvEnrollmentUrl = schoolwork12.app.tvEnrollmentEndPoint
															.concat(schoolwork12.app.keycodeLoginEndPoint);
													mainModel.hasComputerRuleManagerRole = authentication
															.hasComputerRuleManagerRole();
													mainModel.hasAdministratorRole = authentication
															.hasAdministratorRole();
													mainModel.hasEnrollmentAdvisorRole = authentication
															.hasEnrollmentAdvisorRole();
													mainModel.hasCounselorStaffRole = authentication
															.hasCounselorStaffRole();
													mainModel.hasGradPlanManagerRole = authentication
															.hasGradPlanManagerRole();
													mainModel.isSchoolActive = authentication
															.isSchoolActive();
													mainModel.isGradPlanOn = authentication
															.isGradPlanOn();
													mainModel.isCRETrackingOn = authentication
															.isCRETrackingOn();
													mainModel.showTVEInQuickLinks = authentication.showTVEInQuickLinks();
													mainModel.showPFInQuickLinks = authentication.showPFInQuickLinks();
													mainModel.isEnrollmentOn = authentication.isEnrollmentOn();
													mainModel.hasTeacherRole = authentication.
																			hasTeacherRole();
													mainModel.hasDataManagementRole = authentication.hasDataManagementRole();
													mainModel.hasSchoolDataManagementRole = authentication
															.hasSchoolDataManagementRole();
													mainModel.hasBulkImportRole = authentication
															.hasBulkImportRole();
													mainModel.hasBulkAttendanceAdjusterRole = authentication
															.hasBulkAttendanceAdjusterRole();
													mainModel.hasBulkEditAdditionRequirementRole = authentication
													.hasBulkEditAdditionRequirementRole();
													mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
													mainModel.hasCourseManagementRole = authentication.hasCourseManagementRole();
													mainModel.hasbulkSchoolDataRole = authentication.hasbulkSchoolDataRole();
													mainModel.haspathwayRequirementsRole = authentication.haspathwayRequirementsRole();
													mainModel.hasPathwayRequirementEditRole = authentication.hasPathwayRequirementEditRole();
												});

								eventNotification
										.subscribe(
												schoolwork12.app.auth.events.backButtonClick,
												function() {
													event.preventDefault();
													$window.history.forward();
													mainModel.currentUser = undefined;
													mainModel.loginUserRole = undefined;
													authentication.logout();
												});

								eventNotification
										.subscribe(
												schoolwork12.app.auth.events.userLoggedOut,
												function() {
													mainModel.currentUser = undefined;
													mainModel.loginUserRole = undefined;
													console.log('Logout. Show header.');
													mainModel.isShowAppHeader = true;
												});

								eventNotification
										.subscribe(
												schoolwork12.app.auth.events.userLoginError,
												function() {
													mainModel.currentUser = undefined;
													mainModel.loginUserRole = undefined;
													console.log('Login Error. Do not show header.');
													mainModel.isShowAppHeader = false;
												});

							} ]);

}(angular, schoolwork12));
